import Dispatcher from "Dispatcher";

const safeContextDispatch = (context, payload, isStillNeeded) => {
    if (Dispatcher.isDispatching()) {
        console.warn("deferred dispatch of " + payload.type);
        // eslint-disable-next-line no-settimeout
        setTimeout(() => {
            if (isStillNeeded == null || isStillNeeded()) {
                Dispatcher.contextDispatch(context, payload);
            }
        });
    } else {
        Dispatcher.contextDispatch(context, payload);
    }
};

export default safeContextDispatch;



// WEBPACK FOOTER //
// ./app/data/util/safeContextDispatch.js